// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AMpN","colBig":"styles_colBig__tdX4O","colSmall":"styles_colSmall__12wsO"};